export default "__VITE_ASSET__Djmh1c$N__"